import {
    Box,
    Grid,
    GridItem,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Text,
} from '@chakra-ui/react';
import React, { useEffect, useRef } from 'react';
import type { SubscriptionInfo } from './TableSection';
import { StyledBox } from './styles';

interface Props {
    valuesName: { [key: string]: string };
    mainCategories: { [key: string]: string };
    tableSection: SubscriptionInfo[];
    columns: Number;
    isOpenAll?: Boolean;
    isBlocked?: Boolean;
}

export const TableSectionDesktop = ({
    tableSection,
    mainCategories,
    valuesName,
    columns,
    isOpenAll,
    isBlocked,
}: Props) => {
    const firstAccordionButtonRef = React.useRef<HTMLButtonElement>(null);
    const allowMultiple = isOpenAll ? true : undefined;

    const TableSectionContent = (section: SubscriptionInfo) => {
        return (
            <Grid
                gridTemplateColumns={{
                    base: '0.5fr 1fr',
                    lg: `180px repeat(var(--table-cols, ${columns}), minmax(100px, 1fr))`,
                }}
            >
                <Box
                    p={{ base: 4, lg: 5 }}
                    h={'100%'}
                    display={'flex'}
                    alignItems={{ base: 'flex-start' }}
                    justifyContent={{ base: 'flex-start', lg: 'center' }}
                    color={'#171717'}
                    fontSize={'xs'}
                    fontWeight={'normal'}
                    lineHeight={'150%'}
                    borderBottom={{ lg: 'none' }}
                    flexDirection={{ lg: 'column' }}
                >
                    {section.name}
                </Box>

                {Object.keys(section.values).map((keyName, i) => (
                    <StyledBox
                        p={4}
                        h="100%"
                        display={'flex'}
                        alignItems={{ base: 'flex-start', lg: 'center' }}
                        justifyContent={{ base: 'flex-start', lg: 'center' }}
                        color={'#171717'}
                        fontSize={'xs'}
                        fontWeight={'normal'}
                        lineHeight={'150%'}
                        // dangerouslySetInnerHTML={{ __html: section.values[keyName] }}
                    >
                        {section.values[keyName]}
                    </StyledBox>
                ))}
            </Grid>
        );
    };

    const accordionItemRefs: any = useRef([]);

    const openAllElements = () => {
        accordionItemRefs.current.forEach((item: any, index: number) => {
            setTimeout(() => {
                item.querySelector('button').click();
            }, 200);
        });
    };

    useEffect(() => {
        let hasClicked = false;
        const handleScroll = () => {
            if (isOpenAll) {
                openAllElements();
                window.removeEventListener('scroll', handleScroll);
                return;
            }

            if (!hasClicked && accordionItemRefs.current[0]) {
                const { top } = accordionItemRefs.current[0].getBoundingClientRect();
                const viewportHeight = window.innerHeight;
                const threshold = 0.6;

                if (top <= viewportHeight * threshold) {
                    const firstAccordionButtonRef =
                        accordionItemRefs.current[0].querySelector('button');
                    if (firstAccordionButtonRef) {
                        firstAccordionButtonRef.click();
                        hasClicked = true; // Wyłącz nasłuchiwanie po pierwszym kliknięciu
                    }
                }
            }
            // window.removeEventListener('scroll', handleScroll);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleAccordionChange = (index: number) => {
        const currentAccordionItem = accordionItemRefs.current[index];
        console.log('handleAccordionChange', currentAccordionItem);

        if (currentAccordionItem) {
            setTimeout(() => {
                const offsetTop = currentAccordionItem.offsetTop;
                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth',
                });
            }, 300);
        }
    };
    return (
        <Box>
            <Grid
                gridTemplateColumns={{
                    base: '0.5fr 1fr',
                    lg: `180px repeat(var(--table-cols,  ${columns}), minmax(100px, 1fr))`,
                }}
                textAlign={'center'}
                color={'#1aac7a'}
                fontSize={'21px'}
                fontWeight={'600'}
                textTransform={'capitalize'}
                position={isBlocked ? 'relative' : 'sticky'}
                top={isBlocked ? '0' : '80px'}
                background={'white'}
                zIndex={'5'}
                borderBottom={'1px solid #e0e0e0'}
            >
                <Box
                    p={{ base: 4, lg: 5 }}
                    h={'100%'}
                    display={'flex'}
                    alignItems={{ base: 'flex-start', lg: 'center' }}
                    justifyContent={{ base: 'flex-start', lg: 'center' }}
                    color={'#171717'}
                    fontSize={'xs'}
                    fontWeight={'normal'}
                    lineHeight={'150%'}
                    borderBottom={{ lg: 'none' }}
                    flexDirection={{ lg: 'column' }}
                ></Box>
                {Object.keys(valuesName).map((keyName, i) => (
                    <StyledBox
                        padding={'10px 15px'}
                        display={'flex'}
                        justifyContent={'center'}
                        alignItems={'center'}
                    >
                        {valuesName[keyName]}
                    </StyledBox>
                ))}
            </Grid>
            {isBlocked ? (
                <Box>
                    {Object.keys(mainCategories).map((mainCat, i) => (
                        <Box
                            key={'accordion-item-' + i}
                            // ref={el => (accordionItemRefs.current[i] = el)}
                            // ref={i === 0 ? firstAccordionRef : undefined}
                        >
                            <Box
                                padding={'10px 15px'}
                                background={
                                    mainCategories[mainCat] === 'Prace indywidualne'
                                        ? '#C8C8C8'
                                        : '#eeeeee'
                                }
                                color={'#171717'}
                                fontSize={'18px'}
                                fontWeight={'600'}
                                justifyContent={'space-between'}
                                // ref={i === 0 ? firstAccordionButtonRef : undefined}
                            >
                                {mainCategories[mainCat]}
                                {/* <AccordionIcon /> */}
                            </Box>
                            {tableSection.map(section => {
                                if (section.category === mainCategories[mainCat]) {
                                    return (
                                        <Box background={section.isGray ? '#EEE' : ''} p={0}>
                                            {TableSectionContent(section)}
                                        </Box>
                                    );
                                } else {
                                    return null;
                                }
                            })}
                        </Box>
                    ))}
                </Box>
            ) : (
                <Accordion
                    allowToggle
                    onChange={handleAccordionChange}
                    allowMultiple={allowMultiple}
                >
                    {Object.keys(mainCategories).map((mainCat, i) => (
                        <AccordionItem
                            key={'accordion-item-' + i}
                            ref={el => (accordionItemRefs.current[i] = el)}
                            // ref={i === 0 ? firstAccordionRef : undefined}
                        >
                            <AccordionButton
                                padding={'10px 15px'}
                                background={
                                    mainCategories[mainCat] === 'Prace indywidualne'
                                        ? '#C8C8C8'
                                        : '#eeeeee'
                                }
                                color={'#171717'}
                                fontSize={'18px'}
                                fontWeight={'600'}
                                justifyContent={'space-between'}
                                ref={i === 0 ? firstAccordionButtonRef : undefined}
                            >
                                {mainCategories[mainCat]}
                                <AccordionIcon />
                            </AccordionButton>
                            {tableSection.map(section => {
                                if (section.category === mainCategories[mainCat]) {
                                    return (
                                        <AccordionPanel
                                            background={section.isGray ? '#EEE' : ''}
                                            p={0}
                                        >
                                            {TableSectionContent(section)}
                                        </AccordionPanel>
                                    );
                                } else {
                                    return null;
                                }
                            })}
                        </AccordionItem>
                    ))}
                </Accordion>
            )}
        </Box>
    );
};
